import { normalizeText } from './formatters';

// détecte si un libellé de departure correspond à Perpignan ou Rivesaltes
export function inferDepartureTagFromLabel(label = '') {
  const s = normalizeText(label);

  // tolérance écriture : perpignan / perp / rivesaltes / rivesalte / rive...
  if (s.includes('perpignan') || /\bperp\b/.test(s)) return 'P';
  if (s.includes('rivesaltes') || s.includes('rivesalte') || /\brive\b/.test(s)) return 'R';

  return null;
}

/**
 * Calcule le poids affiché pour chaque departure :
 * - si departure "Perpignan" => somme des courses tag (P) après ce départ
 *   jusqu'au prochain departure Perpignan (ou fin)
 * - si departure "Rivesaltes" => somme des courses tag (R) après ce départ
 *   jusqu'au prochain departure Rivesaltes (ou fin)
 * - si departure non reconnu => 0 (ou rien)
 */
export function computeDepartureTotals(items = []) {
  const totalsById = {};

  const getDepartureTag = (label = '') => {
    const s = normalizeText(label);
    if (s.includes('perpignan') || /\bperp\b/.test(s)) return 'P';
    if (s.includes('rivesaltes') || s.includes('rivesalte') || /\brive\b/.test(s)) return 'R';
    return null;
  };

  const otherTag = (tag) => (tag === 'P' ? 'R' : tag === 'R' ? 'P' : null);

  // prochain departure du tag demandé après startIdx (exclu), sinon items.length
  const findNextDepartureIndex = (startIdx, tag) => {
    for (let j = startIdx + 1; j < items.length; j++) {
      const it = items[j];
      if (it?.type !== 'departure') continue;
      if (getDepartureTag(it.order_number) === tag) return j;
    }
    return items.length;
  };

  // prochain departure (quel que soit le tag) après startIdx, sinon items.length
  const findNextAnyDepartureIndex = (startIdx) => {
    for (let j = startIdx + 1; j < items.length; j++) {
      if (items[j]?.type === 'departure') return j;
    }
    return items.length;
  };

  // somme des courses (non departure) dans [start..end) pour un tag donné (R/P)
  const sumTagInRange = (start, end, tag) => {
    let sum = 0;
    for (let j = start; j < end; j++) {
      const row = items[j];
      if (!row || row.type === 'departure') continue;
      if (String(row.cornerTag || '').toUpperCase() === tag) {
        sum += Number(row.weight) || 0;
      }
    }
    return sum;
  };

  // somme TOUTES les courses (non departure) dans [start..end) — pour Béziers
  const sumAllInRange = (start, end) => {
    let sum = 0;
    for (let j = start; j < end; j++) {
      const row = items[j];
      if (!row || row.type === 'departure') continue;
      sum += Number(row.weight) || 0;
    }
    return sum;
  };

  for (let i = 0; i < items.length; i++) {
    const dep = items[i];
    if (!dep || dep.type !== 'departure') continue;

    const depTag = getDepartureTag(dep.order_number);
    if (!depTag) {
      // Béziers (libellé non reconnu) : somme toutes les commandes jusqu'au prochain départ
      const nextAny = findNextAnyDepartureIndex(i);
      totalsById[String(dep.id)] = sumAllInRange(i + 1, nextAny);
      continue;
    }

    const oTag = otherTag(depTag);

    // 1) ce que je charge ici = toutes les courses du même tag jusqu'au prochain chargement de même tag
    const nextSame = findNextDepartureIndex(i, depTag);
    const loadedHere = sumTagInRange(i + 1, nextSame, depTag);

    // 2) ce qu'il me reste de l'autre tag après ce point = toutes les courses de l'autre tag
    //    jusqu'au prochain chargement de l'autre tag
    const nextOther = findNextDepartureIndex(i, oTag);
    const remainingOther = sumTagInRange(i + 1, nextOther, oTag);

    totalsById[String(dep.id)] = loadedHere + remainingOther;
  }

  return totalsById;
}
